import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/bet575/images/logo/logo.png';

export default function index() {
  return <Image src={footerLogo} minW="140px" maxW="201px" minH="34px" />;
}
